import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "babimix_install_dismissed";

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY) === "1") return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setShow(false));
    // iOS Safari has no beforeinstallprompt — show manual hint after a short delay
    let t;
    if (isIOS()) {
      t = setTimeout(() => setShow(true), 2500);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      if (t) clearTimeout(t);
    };
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch (e) { /* noop */ }
      setDeferred(null);
      setShow(false);
      return;
    }
    if (isIOS()) setIosHelp(true);
  };

  if (!show) return null;

  return (
    <div data-testid="install-prompt" className="fixed bottom-4 inset-x-3 sm:inset-x-auto sm:right-5 sm:left-auto sm:w-96 z-[60]">
      <div className="rounded-2xl p-4 shadow-2xl border border-white/10 relative overflow-hidden" style={{ background: "#123B4A" }}>
        <div className="absolute -top-10 -right-6 w-40 h-40 rounded-full pointer-events-none" style={{ background: "radial-gradient(circle, rgba(255,90,79,0.4) 0%, transparent 70%)" }} />
        <button data-testid="install-dismiss" onClick={dismiss} className="absolute top-2 right-2 text-white/50 hover:text-white p-1"><X className="w-4 h-4" /></button>
        <div className="relative flex items-start gap-3">
          <img src="/favicon-192.png" alt="BABIMIX" className="w-12 h-12 rounded-xl shrink-0" />
          <div className="flex-1">
            <p className="font-display font-black text-white text-base leading-tight">Installez BABIMIX</p>
            <p className="text-white/70 text-xs mt-0.5">Ajoutez l'app à votre écran d'accueil pour un accès rapide, comme une vraie appli.</p>
            {iosHelp ? (
              <p className="text-white/80 text-xs mt-2 flex items-center gap-1 flex-wrap">
                Appuyez sur <Share className="w-3.5 h-3.5 inline text-[#38B5D8]" /> <b>Partager</b>, puis <b>« Sur l'écran d'accueil »</b>.
              </p>
            ) : (
              <button data-testid="install-btn" onClick={install} className="mt-2.5 inline-flex items-center gap-2 flame-gradient rounded-full px-4 py-2 text-sm font-bold text-white">
                <Download className="w-4 h-4" /> Installer l'application
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
